/**
 * The validated categorical chart palette, one stepped set per mode. Series
 * take these in a fixed slot order (never cycled by rank). The chat's
 * ```chart theme (`apps/web/src/components/chat/chartTheme.ts`) and the
 * interactive HTML pages' `--chart-1…--chart-8` variables (`./htmlPage.ts`)
 * both read it, so a chart in a fence and one in a page wear the same colours.
 */
export type ChartPaletteMode = "light" | "dark";

export const CHART_CATEGORICAL_COLORS: Readonly<Record<ChartPaletteMode, ReadonlyArray<string>>> = {
  light: ["#2a78d6", "#eb6834", "#1baf7a", "#eda100", "#e87ba4", "#008300", "#4a3aa7", "#e34948"],
  dark: ["#3987e5", "#d95926", "#199e70", "#c98500", "#d55181", "#008300", "#9085e9", "#e66767"],
};
